<!--
  RodapeSite — rodapé padrão com logo centralizada, texto curto e copyright.

  Props:
    - logoSrc    : caminho da logo (default: logo-branco.svg)
    - logoAlt    : alt (default: 'OligoCheck')
    - marca      : nome da marca em negrito dentro do texto (default: 'OligoCheck')
    - texto      : texto principal (aparece após "<strong>Marca</strong> — ")
    - direitos   : copy de direitos reservados

  Slots:
    - default    : substitui todo o conteúdo padrão (uso avançado)

  Uso:
    <RodapeSite
      texto="A evolução do OligoScan. Análise mineral intracelular em tempo real."
      direitos="Todos os direitos reservados."
    />
-->
<template>
  <footer class="rodape">
    <slot>
      <img :src="logoSrc" :alt="logoAlt" class="rodape-logo" />
      <p v-if="texto" class="rodape-texto">
        <strong>{{ marca }}</strong> — {{ texto }}
      </p>
      <p class="rodape-copy">
        © {{ ano }} {{ marca }}<span v-if="direitos"> · {{ direitos }}</span>
      </p>
    </slot>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import defaultLogo from '@/assets/images/logo-branco.svg'

defineProps({
  logoSrc: { type: String, default: defaultLogo },
  logoAlt: { type: String, default: 'OligoCheck' },
  marca: { type: String, default: 'OligoCheck' },
  texto: { type: String, default: null },
  direitos: { type: String, default: null }
})

const ano = computed(() => new Date().getFullYear())
</script>

<style scoped>
.rodape {
  background: var(--ds-bg-alt);
  padding: 36px var(--ds-s-5) 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-top: 1px solid var(--ds-border-subtle);
}

.rodape-logo {
  height: 28px;
  opacity: 0.7;
  margin-bottom: 4px;
}

.rodape-texto {
  font-size: 13px;
  color: var(--ds-text-muted);
  margin: 0;
  text-align: center;
  max-width: 520px;
  line-height: 1.5;
}

.rodape-texto strong {
  color: var(--ds-accent);
  font-family: var(--ds-font-bold);
}

.rodape-copy {
  font-size: 11px;
  color: var(--ds-text-faint);
  margin: 0;
  text-align: center;
}
</style>
